import { actionTypes } from './types';

export const roomReactionUpdate = (data) => {
    return {
        type: actionTypes.UPDATE_ROOM_REACTIONS_ENABLE_DATA,
        data
    }
}